// Utility to merge multiple refs into one
export const mergeRefs = (...refs) => {
    return (element) => {
        refs.forEach((ref) => {
            if (typeof ref === 'function') {
                ref(element)
            } else if (ref != null) {
                ref.current = element
            }
        })
    }
}
